import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i4.4
import React from 'react';
import IconWrap from '../../IconWrap';
const Home = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.664 3.59l8 7.112a1 1 0 01.336.747v.051a.5.5 0 01-.5.5H19v8a1 1 0 01-1 1h-4v-7h-4v7H6a1 1 0 01-1-1v-8H3.5a.5.5 0 01-.5-.5v-.051a1 1 0 01.336-.747l8-7.111a1 1 0 011.328 0z",
        fillRule: "evenodd"
    })));
};
Home.displayName = 'Home';
export default Home;
